/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Available_AppointmentsInputs */

const en_job_form_available_appointments = /** @type {(inputs: Job_Form_Available_AppointmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Appointments`)
};

const de_job_form_available_appointments = /** @type {(inputs: Job_Form_Available_AppointmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freie Termine`)
};

/**
* | output |
* | --- |
* | "Available Appointments" |
*
* @param {Job_Form_Available_AppointmentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_available_appointments = /** @type {((inputs?: Job_Form_Available_AppointmentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Available_AppointmentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_available_appointments(inputs)
	return en_job_form_available_appointments(inputs)
});